import { InfoOutlined } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';

export const ErrorInfo = ({
  title,
  info,
}: {
  title: string;
  info?: string;
}) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      direction="column"
      textAlign="center"
      sx={{ height: '100%' }}
      gap={1}>
      <InfoOutlined color="error" fontSize="large" />
      <Typography variant="h4" sx={{ width: '40%' }}>
        {title}
      </Typography>
      {info && <Typography variant="body1">{info}</Typography>}
    </Grid>
  );
};
